import { Typography } from "@mui/material";
import { getUser } from "core/security/securityUtils";

const ProfileName = () => {
  const user = getUser();
  const username = user?.name;

  if (username?.length > 20) {
    return username?.slice(0, 15).concat(" ", "...");
  }

  return username ? (
    <Typography
      sx={{
        display: {
          xs: "none",
          md: "block",
        },
      }}
    >
      {username}
    </Typography>
  ) : null;
};
export default ProfileName;
